import EncryptedStrings from '../constants/EncryptedStrings';
import { ApiEndpoints } from '@/api/ApiEndpoints';

const DEPLOYMENT_TYPES = {
  DEV: 'dev',
  QA: 'qa',
  STAGE: 'stage',
  PRODUCTION: 'production',
};
const environment = window.location.port === '3000' ? DEPLOYMENT_TYPES.DEV : DEPLOYMENT_TYPES.QA;

const BuildProperties = {
  deploymentType: environment,
  isProdEnv() {
    return BuildProperties.deploymentType === DEPLOYMENT_TYPES.PRODUCTION;
  },

  getBaseUrl() {
    switch (this.deploymentType) {
      case DEPLOYMENT_TYPES.DEV:
        return ApiEndpoints.localUrl;
      case DEPLOYMENT_TYPES.QA:
        return ApiEndpoints.qaBaseUrl;
      case DEPLOYMENT_TYPES.STAGE:
        return ApiEndpoints.stageBaseUrl;
      case DEPLOYMENT_TYPES.PRODUCTION:
        return ApiEndpoints.prodBaseUrl;
      default:
        return ApiEndpoints.qaBaseUrl;
    }
  },

  getVendorDashboardWebUrl(){
    switch (this.deploymentType) {
      case DEPLOYMENT_TYPES.PRODUCTION:
        return "https://vendors.bookyourzone.com";
      default:
        return "https://qa-vendors.bookyourzone.com";
    }
  },




  getSecretKey() {
    if (BuildProperties.isProdEnv()) {
      return EncryptedStrings.PROD_secretKeyAes;
    } else {
      return EncryptedStrings.QA_secretKeyAes;
    }
  },

  getClientHostName() {
    if (window.location.host === 'localhost:3000') {
      return 'qa-bhanix-cms.cashe.co.in';
      // return 'qa-collectiondashboard.cashe.co.in';
    } else {
      return window.location.host;
    }
  },
};

export default BuildProperties;
